<template>
  <div>
    <div class="position-absolute top-50 start-50 translate-middle w-75 text-center" v-if="user_data != null">
      <div class="mb-2">
        {{user_data.class}}
      </div>
      <img width="100" height="100" style="border-radius: 50%;" src="https://pbs.twimg.com/media/E5X64ehVcAIb3TW?format=jpg&name=large"/>
      <div class="mt-2 mb-2">
        {{user_data.name}}
      </div>
      <button class="ms-auto me-auto btn btn-secondary shadow-sm" @click="start_course()">Start My Course</button>
    </div>
  </div>
</template>

<script>
export default {
    name: 'Dashboard',
    data(){
      return {
        user_data: null,
      }
    },
    methods:{
      start_course(){
        if(this.user_data.role == "teacher"){
          this.$router.push('/in_class_teacher')
        }else{
          this.$router.push('/in_class_student')
        }
      }
    },
    mounted(){
      this.user_data = this.$store.state.user_data
    },
}
</script>
<style scoped>
.btn{
    border: 2px solid #565A97;
    border-radius: 37px;
    background-color: #ffffff;
    color:  #565A97;
}
</style>